// @flow

export const Display = {
    BLOCK: 'BLOCK',
    INLINE: 'INLINE',
    INLINE_BLOCK: 'INLINE_BLOCK'
};

export type DisplayType = $Keys<typeof Display>;

export const Text = {
    MORE: 'Text.MORE',
    LESS: 'Text.LESS',
    MORE_UP: 'Text.MORE_UP',
    LESS_UP: 'Text.LESS_UP'
};


export const Direction = {
    HORIZONTAL: 'HORIZONTAL',
    VERTICAL: 'VERTICAL'
};

export const TEXT: { [key: $Values<typeof Text>]: string } = {
    [Text.MORE]: 'more',
    [Text.LESS]: 'less',
    [Text.MORE_UP]: 'More',
    [Text.LESS_UP]: 'Less'
};

export const Separator = {
    COMMA: 'COMMA',
    SPACE: 'SPACE',
    NONE: 'NONE'
};

export type SeparatorType = $Keys<typeof Separator>;

export const SEPARATORS: { [key: SeparatorType]: string } = {
    // \u00A0 it`s binding non-breaking space to HTML because browser removing them by default
    [Separator.COMMA]: ',\u00A0',
    [Separator.SPACE]: '\u00A0',
    [Separator.NONE]: ''
};

export const Type = {
    ARRAY: 'ARRAY',
    TEXT: 'TEXT'
};
